const clientsConfidence = {
  key: 'clients-confidence',
  description: 'Clientes confían en nosotros',
  prefix: '+',
  suffix: '',
};

const financedAmount = {
  key: 'financed-amount',
  description: 'Financiados desde el 2020',
  prefix: '+',
};

const averageTimeToFinance = {
  key: 'average-time-to-finance',
  description: 'Tiempo promedio de giro',
  prefix: '<',
  suffix: 'H',
  targetValue: 3,
  from: 10,
};

const statistics = {
  Chile: [
    {
      ...clientsConfidence,
      targetValue: 5000,
      from: 1500,
    },
    {
      ...financedAmount,
      suffix: 'MMM',
      moneySuffix: 'CLP',
      targetValue: 304,
      from: 0,
    },
    averageTimeToFinance,
  ],
  Mexico: [
    {
      ...clientsConfidence,
      targetValue: 5000,
      from: 1500,
    },
    averageTimeToFinance,
  ],
};

export default statistics;
